import { useCallback, useEffect, useState } from "react";

export function useCountdown(initialSeconds?: number) {
  const [endsAt, setEndsAt] = useState<number | undefined>(
    initialSeconds === undefined
      ? undefined
      : Date.now() + initialSeconds * 1000
  );
  const [remaining, setRemaining] = useState<number | undefined>(
    initialSeconds
  );

  const start = useCallback((seconds: number) => {
    setEndsAt(Date.now() + seconds * 1000);
    setRemaining(seconds);
  }, []);

  useEffect(() => {
    if (endsAt === undefined) return;

    const sync = () => {
      const left = Math.max(0, Math.ceil((endsAt - Date.now()) / 1000));
      setRemaining(left);
      return left;
    };
    const interval = window.setInterval(() => {
      if (sync() === 0) window.clearInterval(interval);
    }, 1000);
    document.addEventListener("visibilitychange", sync);

    return () => {
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", sync);
    };
  }, [endsAt]);

  return [remaining, start] as const;
}

export default useCountdown;
